import {
  ajax
} from 'application/src/js/functions.js';

import DynamicOffer from 'application/src/js/trade-items/dynamic-offer.js';
// import ContractOffer from 'application/src/js/trade-items/contract-offer.js';
// import Enquiry from 'application/src/js/trade-items/enquiry.js';

/**
 * @class
 * @param {number} args.rawmaterialid
 * @param {object} args.translations
 * @param {Mediator} args.mediator
 */
export default class OffersAndRequests {
  constructor(args) {
    this.basicIds = args.basicIds;
    this.translations = args.translations;
    this.mediator = args.mediator;

    this.container = document.querySelector('.lp-content .offers-and-requests');
    this.list = this.container.querySelector('.list');

    this.requestUrls = {
      dynamic: '/app/ajax/ajaxLoadRelatedDynamicOffer',
      // contract: '/app/ajax/ajaxLoadRelatedContractOffer',
      // request: '/app/ajax/ajaxLoadRelatedRequest'
    };

    this.user = null;
    this.debugMode = true;
    this.hideClass = 'hide';
    this.numMaxItems = 6;

    this.load()
      .then(response => {
        this.user = response.user;
        this.env = response.env || {
          locale: languageIso
        };

        const dynamicResults = response[0].data;
        const contractResults = []; // response[1].data;
        const requestResults = []; // response[2].data;

        let items = []

        for (let i = 0; i < this.numMaxItems; i++) {
          if (dynamicResults[i] && items.length < this.numMaxItems) items.push(dynamicResults[i]);
          // if (contractResults[i] && items.length < this.numMaxItems) items.push(contractResults[i]);
          // if (requestResults[i] && items.length < this.numMaxItems) items.push(requestResults[i]);
        }

        this.render(items);
        this.mediator.publish('finishedLoading');
      })
      .catch(e => {
        if (this.debugMode && e) console.log(e);
        this.mediator.publish('finishedLoading');
      });
  }

  load() {
    this.mediator.publish('startedLoading');

    return Promise.all([
      ajax(this.requestUrls.dynamic, {
        basicid: this.basicIds,
        per_page: 6,
        per_index: 0,
      }),
      // ajax(this.requestUrls.contract, {
      //   rawmaterialid: this.rawmaterialid,
      //   per_page: 6,
      //   per_index: 0,
      // }),
      // ajax(this.requestUrls.request, {
      //   rawmaterialid: this.rawmaterialid,
      //   per_page: 6,
      //   per_index: 0,
      // })
    ]);
  }

  render(items) {
    // display only even amount of items
    // if (items.length % 2 > 0) items.pop();

    if (items.length) this.container.classList.remove(this.hideClass);
    this.list.innerHTML = '';

    items.map(itemData => {
      const itemElement = document.createElement('div');
      this.list.insertAdjacentElement('beforeend', itemElement);

      const itemParams = {
        parent: this,
        data: itemData,
        element: itemElement,
        user: this.user,
        env: this.env
      };

      if (typeof itemData.dynamic_offer_id !== 'undefined') new DynamicOffer(itemParams);
      // if (typeof itemData.contract_offer_id !== 'undefined') new ContractOffer(Object.assign({}, itemParams, {
      //   translations: this.translations.offers
      // }));
      // if (typeof itemData.request_id !== 'undefined') new Request(Object.assign({}, itemParams, {
      //   translations: this.translations.requests
      // }));
    });
  }
}